import React from 'react';
import { Routes, Route, NavLink, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Messages from './Messages';
import Profile from './Profile';
import Points from './Points';
import Posts from './Posts';
import Comments from './Comments';
import Activities from './Activities';
import { useAuth } from '../../contexts/AuthContext';

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const PageTitle = styled.h1`
  margin-bottom: 30px;
  font-size: 28px;
  color: #333;
`;

const NavContainer = styled.nav`
  display: flex;
  background-color: white;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

interface NavLinkProps {
  isActive: boolean;
}

const NavItem = styled(NavLink)<NavLinkProps>`
  flex: 1;
  padding: 15px 0;
  text-align: center;
  font-weight: ${props => (props.isActive ? 'bold' : 'normal')};
  color: ${props => (props.isActive ? 'white' : '#4b5563')};
  background-color: ${props => (props.isActive ? '#ef4444' : 'transparent')};
  text-decoration: none;
  transition: all 0.2s;
  
  &:hover {
    background-color: ${props => (props.isActive ? '#dc2626' : '#f3f4f6')};
  }
`;

const MyPage: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();
  
  // 로그인이 안 되어 있는 경우 처리
  if (!isAuthenticated || !user) {
    return (
      <PageContainer>
        <div>로그인이 필요한 서비스입니다.</div>
      </PageContainer>
    );
  }
  
  return (
    <PageContainer>
      <PageTitle>마이페이지</PageTitle>
      
      <NavContainer>
        <NavItem 
          to="/mypage/info" 
          isActive={location.pathname === '/mypage/info'}
        >
          내 정보
        </NavItem>
        <NavItem 
          to="/mypage/activities" 
          isActive={location.pathname === '/mypage/activities'}
        >
          활동내역
        </NavItem>
        <NavItem 
          to="/mypage/points" 
          isActive={location.pathname === '/mypage/points'}
        >
          포인트
        </NavItem>
        <NavItem 
          to="/mypage/messages" 
          isActive={location.pathname === '/mypage/messages'}
        >
          내 쪽지함
        </NavItem>
        <NavItem 
          to="/mypage/posts" 
          isActive={location.pathname === '/mypage/posts'}
        >
          내 게시글
        </NavItem>
        <NavItem 
          to="/mypage/comments" 
          isActive={location.pathname === '/mypage/comments'}
        >
          내 댓글
        </NavItem>
      </NavContainer>
      
      <Routes>
        <Route path="info" element={<Profile />} />
        <Route path="activities" element={<Activities />} />
        <Route path="points" element={<Points />} />
        <Route path="messages" element={<Messages />} />
        <Route path="posts" element={<Posts />} />
        <Route path="comments" element={<Comments />} />
      </Routes>
    </PageContainer>
  );
};

export default MyPage; 